import React from "react"
import PropTypes from "prop-types"
import { Typography } from "@mui/material"
import i18n from "i18n"

import { formatChartNumber } from "./utils/numberFormat"
import OverviewCard, {
  overviewCardValueSx,
  overviewCardHelperTextSx,
} from "./OverviewCard"

const ExpectedCostCard = ({
  expectedCostAtDate,
  costObjective,
  advancePercentage,
  hasCertifications,
  isLoading,
  currency,
}) => (
  <OverviewCard
    iconPreset="expectedCostAtDate"
    title={i18n.t("overview.expectedCostCardTitle")}
    infoText={i18n.t("overview.expectedCostCardTooltip")}
    loading={isLoading}
    sx={{ height: "100%" }}
  >
    <Typography sx={overviewCardValueSx}>
      {formatChartNumber(expectedCostAtDate, 2)} {currency}
    </Typography>
    <Typography variant="body2" sx={overviewCardHelperTextSx}>
      {hasCertifications
        ? i18n.t("overview.expectedCostCardHelper", {
            percent: advancePercentage.toFixed(1),
          })
        : i18n.t("overview.expectedCostCardNoCertificationsHelper")}
    </Typography>
  </OverviewCard>
)

ExpectedCostCard.propTypes = {
  expectedCostAtDate: PropTypes.number.isRequired,
  costObjective: PropTypes.number,
  advancePercentage: PropTypes.number,
  hasCertifications: PropTypes.bool,
  isLoading: PropTypes.bool,
  currency: PropTypes.string,
}

ExpectedCostCard.defaultProps = {
  hasCertifications: false,
}

export default ExpectedCostCard
